/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/

export class EmployeeDto {
    constructor(
        public _id: string,
        public full_name:string,
        public email: string,
        public user_name:string,
        public employee_group:string[],
        public start_screen_configuration :object[],
    ) { }
}

export class CreateEmployeeDto {
    constructor(
        public full_name:string,
        public email: string,
        public user_name:string,
        public employee_group:string[],
        public start_screen_configuration :object[],
    ) { }
}

